import styles from './styles';

function AudiencesFormHeader({ classes, subtitle, title }) {
  return (
    <div className={classes.root}>
      <div>{title}</div>
      <div>{subtitle}</div>
    </div>
  );
}

AudiencesFormHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(AudiencesFormHeader);
